import { Typography } from "@mui/material";

import withStyles from "utils/withStyles";

export default withStyles(theme=>({
  root: {
    color: '#646464',
    [theme.breakpoints.down('md')]:{
      lineHeight:1
    }
  },
}))(Typography);
